let productsOnPage = document.getElementById("product-grid");
let nextUrl = productsOnPage.dataset.nextUrl;

async function getNextPage(nextUrl) {
  try {
    let res = await fetch(nextUrl);
    return await res.text();
  } catch (error) {
    console.log({ error });
  }
}

async function loadMoreProducts(shouldRetargetUrl = false) {
  if (shouldRetargetUrl) {
    productsOnPage = document.getElementById("product-grid");
    nextUrl = productsOnPage.dataset.nextUrl;
    return;
  }

  updateLoadMoreButton({ isLoading: true });

  let nextPage = await getNextPage(nextUrl);
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, "text/html");
  const productGrid = nextPageDoc.getElementById("product-grid");
  const newProducts = productGrid.querySelectorAll(".grid__item--product");
  const newUrl = productGrid.dataset.nextUrl;

  updateLoadMoreButton({ isLoading: false, newUrl });

  nextUrl = newUrl;

  if (!nextUrl) {
    productsOnPage.setAttribute("products-load-complete", "");
  }

  for (const newProduct of newProducts) {
    productsOnPage.appendChild(newProduct);
  }
  const shouldUseMarketingTilesSideEffects =
    document.getElementById("marketing-tiles");
  if (shouldUseMarketingTilesSideEffects) {
    loadMoreButtonInjectTiles();
    totalTilesPerPage(!nextUrl);
  }
  productsOnPage.addEventListener("click", saveGridProducts);
}

function updateLoadMoreButton({ isLoading, newUrl }) {
  const loadMoreBtn = document.getElementsByClassName("load-more__btn")[0];
  const loadMoreSpinner =
    document.getElementsByClassName("load-more__spinner")[0];

  if (isLoading) {
    loadMoreBtn.setAttribute("loading", "");
    loadMoreBtn.classList.toggle("hidden");
    loadMoreSpinner.classList.toggle("block");
  } else {
    loadMoreBtn.removeAttribute("loading");
    loadMoreSpinner.classList.toggle("block");
    if (newUrl) {
      loadMoreBtn.classList.toggle("hidden");
    }
  }
}

function saveGridProducts(event) {
  productsOnPage.dataset.nextUrl = nextUrl;
  let previousGrid = productsOnPage.outerHTML;
  localStorage.setItem("cached_products_plp", previousGrid);
  localStorage.setItem("cached_selected_plp", event.target.id);
}

function restoreGridProducts() {
  const previousGrid = localStorage.getItem("cached_products_plp");

  if (!previousGrid) return;

  const parser = new DOMParser();
  const grid = parser.parseFromString(previousGrid, "text/html");
  const productGrid = grid.getElementById("product-grid");
  const savedProducts = productGrid.querySelectorAll(".grid__item--product");

  nextUrl = productGrid.dataset.nextUrl;

  updateLoadMoreButton({ isLoading: true, newUrl: nextUrl });

  productsOnPage.replaceChildren(...savedProducts);

  updateLoadMoreButton({ isLoading: false, newUrl: nextUrl });

  productsOnPage.addEventListener("click", saveGridProducts);
  localStorage.removeItem("cached_products_plp");

  const previousProductId = localStorage.getItem("cached_selected_plp");
  const productCard = productsOnPage.querySelector(`#${previousProductId}`);
  productCard.focus();
}
